export const getSlugFromString = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '-')
}
